var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x83\x8D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M59.264 43.072L55.872 47.424C50.304 43.328 46.464 40.768 40.512 37.568L43.84 33.856C49.856 37.056 53.312 39.104 59.264 43.072Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M41.5 35.5C47.5902 38.766 51.5898 41.0182 58 45.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M29.696 34.304L34.816 32.128V51.648C34.816 53.888 34.944 56.768 35.136 58.752H29.312C29.504 56.832 29.696 53.888 29.696 51.648V34.304Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M32 32V59",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    d: "M52.928 17.344L49.536 14.08C48.512 14.4 47.04 14.528 45.504 14.528C41.664 14.528 20.224 14.528 17.28 14.528C15.104 14.528 11.584 14.4 9.536 14.144V19.584C11.456 19.392 15.168 19.328 17.344 19.328C20.224 19.328 40.96 19.328 43.968 19.328C41.728 22.336 36.672 27.328 30.912 31.04C25.152 34.816 17.152 38.976 4.992 41.92L8.128 46.656C19.072 43.328 27.456 39.616 34.432 34.752C40.512 30.592 46.016 25.088 49.344 21.184C50.368 19.968 51.776 18.496 52.928 17.344Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_3",
    d: "M9.5 17H50C37 32 24.5 39.5 5.5 44.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    d: "M29.504 4.79999H35.328C35.072 6.14399 34.944 8.63999 34.944 10.368V16.704H29.824V10.368C29.824 8.57598 29.76 6.20798 29.504 4.79999Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_4",
    d: "M32.5 4.5V17",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNe);
export default __webpack_public_path__ + "static/media/ne.12cce167aa7072a046d065fcc1f93b28.svg";
export { ForwardRef as ReactComponent };